import { Grid } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { getLiquidacionesDinerarias } from "../../../../../../redux/actions/dinerarias";
import CardContainer from "../../../../../commons/cards/CardContainer";
import { StyledSiniestralidad } from "../../../../../styled/Siniestros";
import DinerariasCard from "./cards/DinerariasCard";
import DinerariasHelperLabel from "./labels/DinerariasHelperLabel";

const Dinerarias = ({ selectedAccident }) => {
  const dispatch = useDispatch();

  const liquidacionesDinerarias = useSelector(
    (state) => state.dinerarias.liquidaciones
  );

  return (
    <>
      <StyledSiniestralidad.ContentContainer container>
        <Grid container item xs={12}>
          <DinerariasHelperLabel />
        </Grid>
        <Grid item xs={10}>
          <CardContainer
            title="Estado de las Liquidaciones"
            loading={liquidacionesDinerarias.loading}
            getData={() =>
              dispatch(
                getLiquidacionesDinerarias(
                  selectedAccident?.idSiniestroCabecera
                )
              )
            }
            componente={<DinerariasCard data={liquidacionesDinerarias.data} />}
          />
        </Grid>
      </StyledSiniestralidad.ContentContainer>
    </>
  );
};

export default Dinerarias;
